<template>
  <div>
    <div>
      <b-navbar toggleable="lg" type="dark"  class="header-bg">

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <!--<b-navbar-toggle right target="nav-collapse"></b-navbar-toggle>-->
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item @click="goToEventHome">
              <b-button variant="light" class="pt-2 pb-1 header-text ">
                <i class="fas fa-home"></i>
              </b-button>
            </b-nav-item>
            <b-nav-item @click="goToEventform">
              <b-button variant="light" class="pt-2 pb-1 header-text ">
                <i class="fas fa-plus"></i> เหตุการณ์
              </b-button>
            </b-nav-item>
            <b-nav-item @click="openDashboard">
              <b-button variant="light" class="pt-2 pb-1 header-text ">
                Dashboard
              </b-button>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-dropdown >
            <!-- Using 'button-content' slot -->
            <template slot="button-content">
              <template v-if="user_login && user_login.user">
                                    <span  class="user-header-text">
                                        {{user_login.user.first_name}}
                                      <!--                                        <img :src="user_login.user.avatar" class=" img-user rounded-circle">-->
                                    </span>
              </template>
              &nbsp;
            </template>
            <b-dropdown-item @click="logout">ออกจากระบบ</b-dropdown-item>
          </b-nav-dropdown>
        </b-navbar-nav>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { CryptoJS } from '../../util/cryptojs-aes.min'
import { CryptoJSAesJson } from '../../util/cryptojs-aes-format'
import { domain_dashboard } from '../../util/Constants'

export default {
  name: 'StatusHeader',
  created () {
    this.checkLogin()
  },
  computed: {
    ...mapState({
      user_login: state => {
        return state.Auth.user_login
      }
    })
  },
  data () {
    return {
    }
  },
  methods: {
    checkLogin () {
      if (this.user_login == null) {
        this.$router.push({ name: 'LoginView' })
      }
    },
    logout () {
      this.$store.dispatch('Auth/logout').then(() => {
        this.$router.push({ name: 'LoginView' })
      })
    },
    goToEventHome () {
      window.open('https://drowningreport.ddc.moph.go.th/drowningdashboard/public/index.php/deathcert','_self')
    },
    goToEventform () {
      this.$store.dispatch('Event/clearFormData')
      this.$router.push('/event-form')
    },
    openDashboard () {
      if (this.user_login && this.user_login.user) {
        let token = this.user_login.user.user_type_id + ',' + moment().format('YYYY-MM-DD')

        let encryptedJson = this.encrypt(token)
        while (encryptedJson.ct.includes('+')) {
          encryptedJson = this.encrypt(token)
        }

        let ct = encryptedJson.ct

        // let decrypted = CryptoJS.AES.decrypt(encrypted, password, { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8)
        window.open(
          domain_dashboard + '?ct=' + ct + '&iv=' + encryptedJson.iv + '&s=' + encryptedJson.s,
          '_blank' // <- This is what makes it open in a new window.
        )
      }
    },
    encrypt (token) {
      let password = 'secret'
      let encrypted = CryptoJS.AES.encrypt(JSON.stringify(token), password, { format: CryptoJSAesJson }).toString()
      return JSON.parse(encrypted)
    }
  }
}
</script>

<style scoped>

.dropdown-item{
  font-weight: 700!important;
}

.header-bg{
  background-color: #006738;
  height: fit-content;
  padding-top: 10px;
  padding-left: 18px;
  padding-right: 15px;
}

.header-text{
  color: #006738;
  background-color: white;
  border-radius: 5px;
  text-align: center;
  display: inline;
  font-weight: 700;
  font-size: 24px;
}

.user-header-text{
  color: white;
  font-weight: 700;
  font-size: 24px;
}

.img-user{
  height: 30px;
  width: 30px;
}

@media only screen and (max-width: 767px) {
  .header-text{
    font-size: 20px;
  }
}
</style>
